import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../services/api';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

export default function Historial({ onTabChange, onOpenPackage }) {
  const { token, user } = useAuth();
  const [paquetes, setPaquetes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/packages/historial', {}, token)
      .then(data => { setPaquetes(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const getRol = (pkg) => {
    if (pkg.senderId === user?.id) return { label: 'Remitente', emoji: '📦', color: '#f97316' };
    if (pkg.driverId === user?.id) return { label: 'Viajero', emoji: '🚗', color: '#3b82f6' };
    return { label: 'Receptor', emoji: '🎁', color: '#22c55e' };
  };

  return (
    <div style={{minHeight:'100vh', backgroundColor:'#111318', paddingBottom:'96px'}}>
      <Navbar onOpenPackage={onOpenPackage} />

      <div style={{maxWidth:'480px', margin:'0 auto', padding:'20px 16px'}}>
        <div style={{marginBottom:'24px'}}>
          <p style={{color:'#f97316', fontSize:'12px', fontWeight:'600', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'6px'}}>
            Historial
          </p>
          <h1 style={{color:'white', fontWeight:'800', fontSize:'26px', letterSpacing:'-0.02em'}}>
            Envíos completados
          </h1>
          <p style={{color:'#6b7280', fontSize:'13px', marginTop:'4px'}}>
            {paquetes.length} envíos en total
          </p>
        </div>

        {loading && (
          <p style={{color:'#6b7280', fontSize:'14px', textAlign:'center', padding:'40px 0'}}>Cargando...</p>
        )}

        {!loading && paquetes.length === 0 && (
          <div style={{textAlign:'center', padding:'60px 0'}}>
            <p style={{fontSize:'48px', marginBottom:'16px', opacity:0.2}}>📦</p>
            <p style={{color:'#6b7280', fontSize:'14px'}}>Aún no tienes envíos completados</p>
            <p style={{color:'#3a3d45', fontSize:'12px', marginTop:'6px'}}>Cuando completes un envío aparecerá aquí</p>
          </div>
        )}

        {paquetes.map(pkg => {
          const rol = getRol(pkg);
          return (
            <div key={pkg.id} style={{backgroundColor:'#1a1d24', border:'1px solid #2a2d35',
              borderRadius:'16px', padding:'16px', marginBottom:'10px'}}>
              <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'10px'}}>
                <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                  <span style={{fontSize:'18px'}}>{rol.emoji}</span>
                  <div>
                    <p style={{color:'white', fontWeight:'700', fontSize:'14px'}}>{pkg.from} → {pkg.to}</p>
                    <span style={{backgroundColor:`${rol.color}15`, color: rol.color,
                      fontSize:'10px', fontWeight:'600', padding:'2px 8px', borderRadius:'20px'}}>
                      {rol.label}
                    </span>
                  </div>
                </div>
                <span style={{backgroundColor:'#22c55e15', color:'#22c55e',
                  fontSize:'10px', fontWeight:'600', padding:'3px 10px', borderRadius:'20px'}}>
                  ✅ Completado
                </span>
              </div>

              <div style={{display:'flex', gap:'8px', flexWrap:'wrap'}}>
                {pkg.sender && (
                  <div style={{display:'flex', alignItems:'center', gap:'6px',
                    backgroundColor:'#111318', borderRadius:'10px', padding:'6px 10px'}}>
                    {pkg.sender.avatar
                      ? <img src={pkg.sender.avatar} style={{width:'20px', height:'20px', borderRadius:'50%', objectFit:'cover'}} />
                      : <div style={{width:'20px', height:'20px', borderRadius:'50%', backgroundColor:'#f97316',
                          display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px', color:'white', fontWeight:'bold'}}>
                          {pkg.sender.name?.charAt(0)}
                        </div>
                    }
                    <p style={{color:'#9ca3af', fontSize:'11px'}}>{pkg.sender.name}</p>
                  </div>
                )}
                {pkg.driver && (
                  <div style={{display:'flex', alignItems:'center', gap:'6px',
                    backgroundColor:'#111318', borderRadius:'10px', padding:'6px 10px'}}>
                    {pkg.driver.avatar
                      ? <img src={pkg.driver.avatar} style={{width:'20px', height:'20px', borderRadius:'50%', objectFit:'cover'}} />
                      : <div style={{width:'20px', height:'20px', borderRadius:'50%', backgroundColor:'#3b82f6',
                          display:'flex', alignItems:'center', justifyContent:'center', fontSize:'10px', color:'white', fontWeight:'bold'}}>
                          {pkg.driver.name?.charAt(0)}
                        </div>
                    }
                    <p style={{color:'#9ca3af', fontSize:'11px'}}>{pkg.driver.name}</p>
                  </div>
                )}
              </div>

              <p style={{color:'#3a3d45', fontSize:'11px', marginTop:'10px'}}>
                {new Date(pkg.createdAt).toLocaleDateString('es-ES', {day:'numeric', month:'long', year:'numeric'})}
              </p>
            </div>
          );
        })}
      </div>

      <BottomNav active="historial" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}